import { Dropdown } from 'antd';
import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';
import MultiSelectOverlay from '../MultiSelectOverlay';
import { DropdownLabel, RotateIcon } from '../styled';
const ClosedText = styled.span `
  text-align: left;
`;
// Designed to work with `getFieldDecorator` forms, hence the forwardRef. We
// don't actually use the ref for anything, though it could be handy in a
// future version. For now it's easier to use the `form` object directly.
export const MultiSelect = forwardRef(({ closedLabel, displayName, onConfirm, onReset, onCancel, onSelect, selected, options, disabled, showAll, showSearch, shifted, closeOnReset }, _) => {
    const [visible, setVisible] = useState(false);
    const confirm = () => {
        if (!!onConfirm) {
            onConfirm();
        }
        setVisible(false);
    };
    const reset = () => {
        if (!!onReset) {
            onReset();
        }
        else {
            onSelect([]);
        }
        if (closeOnReset) {
            setVisible(false);
        }
    };
    const visibilityChanged = () => {
        setVisible(!visible);
        if (visible && !!onCancel) {
            onCancel();
        }
    };
    const onSelectProxy = (selected) => {
        const items = selected.map(e => e.value);
        onSelect(items);
    };
    return (React.createElement(Dropdown, { disabled: disabled, onVisibleChange: visibilityChanged, overlay: React.createElement(MultiSelectOverlay, { displayName: displayName || closedLabel, onConfirm: confirm, onReset: reset, onSelect: onSelectProxy, options: options, selected: selected, showAll: showAll, showSearch: showSearch, shifted: shifted, visible: visible }), trigger: ['click'], visible: visible },
        React.createElement(DropdownLabel, { onClick: e => e.preventDefault() },
            React.createElement(ClosedText, null, closedLabel),
            React.createElement(RotateIcon, { type: "down", rotate: visible ? 180 : 0 }))));
});
export default MultiSelect;
